'use strict';

/**
 * All JS for any action of the UsersController on the server side
 */
if (waApp.controllers.PsaCms == undefined) {
	waApp.controllers.PsaCms = {};
}

/**
 * @todo Figure out how to move the error message of jquery validator after the select2
 * injected input widget.
 * @todo Submit the form when valid and upload the images AFTER it was successfully saved.
 */
waApp.controllers.PsaCms.CmsPages = {
	view: function() {
		waUtils.noWrapArrowLink('.related-articles-title', 'wa-arrow-medium');
	},
	submitWorks: function() {
		let template = $('#photo-template').html();
		Mustache.parse(template);
		let photoIterator = 1;
		let rendered = Mustache.render(template, {
			iterator: photoIterator,
		});
		$('.photos').append(rendered);

		$('a.add-photo').on('click', function(e) {
			e.preventDefault();
			photoIterator++;
			rendered = Mustache.render(template, {
				iterator: photoIterator,
			});
			$('.photos').append(rendered);
		});

		$('.photos').on('change', 'input[type=file]', function(e) {
			e.preventDefault();

			let id = $(this).data('photo-id');
			let reader = new FileReader();

			reader.onload = function(e) {
				let image = new Image();
				image.src = e.target.result;

				image.onload = function() {
					console.log(this.naturalWidth);

					$('#photo-' + id).find('img').remove();
					$('#photo-' + id + ' .delete-photo').show();
					$('<img src=""/>').attr('src', this.src).prependTo('#photo-' + id);
				};
			};

			reader.readAsDataURL(this.files[0]);
		});

		$('.photos').on('click', '.delete-photo', function(e) {
			e.preventDefault();
			let photoId = $(this).data('photo-id');
			$('#photo-' + photoId).remove();
		});

		$('#country-id').select2({
			placeholder: $('#country-id').attr('placeholder'),
			allowClear: true
		});
		$('#state-id').select2({
			placeholder: $('#state-id').attr('placeholder'),
			allowClear: true
		});

		waUtils.stateSelect('#country-id', '#state-id');
		waUtils.textRemaining('#teaser-text', '#teaser-text-counter', 250);

		$.validator.addMethod('validcmsimagecount', function(value, element) {
			return $('.photo-container img').length > 0;
		}, 'You must add at least one image.');

		$.validator.addMethod('extension', function(value, element, param) {
			param = typeof param === 'string' ? param.replace(/,/g, '|') : 'png|jpe?g';
			return this.optional(element) || value.match(new RegExp('\\.(' + param + ')$', 'i'));
		}, $.validator.format('Please enter a value with a valid extension.'));

		$.validator.addMethod('validImageSize', function(value, element) {
			// var file = element.files[0];
			// var img = new Image();
			// var result = false;
			//
			// img.onload = function() {
			// 	result = img.width >= 1200;
			// 	console.log(result);
			// };
			//
			// img.src = file
			// console.log(result);
			// return result;

		}, $.validator.format('The image must be at least 1200px width'));

		$('#submit-work-form').bind('DOMSubtreeModified', function(e) {
			let countryError = $('#country-id-error');
			if (countryError.length > 0) {
				countryError.appendTo(countryError.parent());
			}
		});

		let validator = $('#submit-work-form').validate({
			framework: 'bootstrap',
			ignore: [],
			submitHandler: function(form) {
				form.submit();
			}
		});

		// This is required because for some reason the validation doesn't pick
		// up the change automatically. Guess this is related to how select2
		// handles the events or whatever
		$('#country-id').on('change', function() {
			validator.element('#country-id');
		});

		/*
		var photoIterator = 0;

		// Find and cache the DOM elements we'll be using.
		var dom = {
			uploader: $("#dropzone"),
			uploads: $(".photos")
		};

		var uploader = new plupload.Uploader({
			runtimes: 'html5',
			url: '/files/upload/CmsImageElement.json',
			drop_element: 'dropzone',
			browse_button: 'dropzone',
			filters: {
				image_resolution: {
					width: {
						size: 200,
						operator: '<='
					},
				},
				mime_types: [
					{
						title: 'Image files',
						extensions: 'jpg, png'
					}
				],
			}
		});

		uploader.bind( "PostInit", handlePluploadInit );
		uploader.bind( "FilesAdded", handlePluploadFilesAdded );
		uploader.init();

		function handlePluploadInit( uploader, params ) {
			//console.log( "Initialization complete." );
			//console.log( "Drag-drop supported:", !! uploader.features.dragdrop);
		}

		// I handle the files-added event. This is different
		// that the queue-changed event. At this point, we
		// have an opportunity to reject files from the queue.
		function handlePluploadFilesAdded( uploader, files ) {
			// console.log( "Files selected." );
			// Show the client-side preview using the loaded File.
			for (var i = 0 ; i < files.length ; i++) {
				showImagePreview(files[i]);
			}
		}

		// I take the given File object (as presented by
		// Plupoload), and show the client-side-only preview of
		// the selected image object.
		function showImagePreview(file) {
			console.log(file);
			var template = $('#photo-template').html();
			Mustache.parse(template);
			var rendered = Mustache.render(template, {
				//image: image.outerHTML,
				iterator: photoIterator++,
				photoId: file.id
			});

			var rendered = $(rendered);

			var item = $( "<div></div>" ).appendTo( dom.uploads );
			var image = $( new Image() ).prependTo( rendered );
			rendered.appendTo(item);

			var preloader = new mOxie.Image();
			// Define the onload BEFORE you execute the load()
			// command as load() does not execute async.
			preloader.onload = function() {
				preloader.downsize( 300, 300 );
				image.prop( "src", preloader.getAsDataURL() );
			};
			preloader.load( file.getSource() );
		}

		// Remove photo elements from the list on click
		$('.photos').on('click', '.delete-photo', function(e) {
			e.preventDefault();

			var photoId = $(this).data('photo-id');
			$('#' + photoId).remove();

			// Remove the file from pluploads stack
			length = photoUploader.files.length;
			for (i = 0; i < length; ++i) {
				if (i in photoUploader.files) {
					id = photoUploader.files[i].id;
					if (id == photoUploader.files) {
						uploader.splice(i, 1);
						photoIterator--;
						$('#image-count').val(photoIterator);
					}
				}
			}
		});
		*/
	}
};
